<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{margin:0;padding:0;font-family: 'Segoe UI',SegoeUI,'Microsoft YaHei',微软雅黑,"Helvetica Neue",Helvetica,Arial,sans-serif}
html, body, #app{width:100%;height:100%;color:#333}
a, a:link, a:visited, a:hover, a:active{color:#333}
html, body, h1, h2, h3, h4, h5, h6{font-weight:300}
h1, h2, h3, h4, h5, h6{padding:5px 0}

.pull-left{float:right}
.pull-right{float:right}

.size-xs{font-size:10px}
.size-s{font-size:12px}
.size-m{font-size:14px}

.color-describe{color:#999}
.color-focus{color:#ED6A0C}
.color-price{color:#f00}
.color-white{color:#fff}

.bg-white{background:#fff}
.bg-primary{background:#dc5052}
.bg-warning{background:#E6A23C}

.text-center{text-align:center}
.text-left{text-align:left}
.text-right{text-align:right}

.avatar-m{width:60px;height:60px}

.card{border-radius:5px;box-shadow:0 0 5px #bbb;display:block;padding:10px;overflow:hidden}
.card-select{border-radius:5px;box-shadow:0 0 5px #ED6A0C;display:block;padding:10px;overflow:hidden}

.margin-tb-5{margin-top:5px!important;margin-bottom:5px!important}
.margin-tb-10{margin-top:10px!important;margin-bottom:10px!important}
.margin-tb-15{margin-top:15px!important;margin-bottom:15px!important}
.margin-tb-20{margin-top:20px!important;margin-bottom:20px!important}

.margin-10{margin:10px}
.padding-10{padding:10px}
.padding-20{padding:20px}

.submit-block{width:100%;height:53px}
.submit{position:fixed;bottom:0;width:100%;height:53px;background:#fff;border-top:#ddd 1px solid}
.submit .wrapper{margin:5px}

.line{border-bottom: #eee 1px solid}
.block{width:100%;height:10px;background-color:#eee}

.van-field__label{color: #333}
</style>



// WEBPACK FOOTER //
// src/App.vue